import EmiHomeSkeletonScreen from './EmiHome';
import LendersListSkeletonScreen from './LendersListSkeleton';
import LenderDetailsSkeleton from './LenderDetailsSkeleton';
import SalesSupportSkeletonScreen from './SalesSupport';
import { Fragment } from 'preact';

const SalesAppSkeleton = ({ path }) => {
  const renderLoader = (path) => {
    switch (path) {
      case '/sales-emi-home':
        return <EmiHomeSkeletonScreen />;

      case '/sales-lenders-list':
        return <LendersListSkeletonScreen />;

      case '/sales-lender-details':
        return <LenderDetailsSkeleton />;

      case '/sales-support':
        return <SalesSupportSkeletonScreen />;

      default:
        return null;
    }
  };

  return <Fragment>{renderLoader(path)}</Fragment>;
};

export default SalesAppSkeleton;



// WEBPACK FOOTER //
// ./components/salesApp/skeletonScreens/index.js